import { useState, useEffect } from "react";
import { loadDefaultParameterConfig } from "../services/defaultparameterconfig";

const useDefaultParameterConfig = () => {
    const [defaultParameterConfig, setDefaultParameterConfig] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loading, setLoading] = useState(true);  // Add loading state here

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await loadDefaultParameterConfig();
                if (data) {
                    setDefaultParameterConfig(data);
                    setIsDataLoaded(true);
                }
            } catch (error) {
                console.error(error.message);
            } finally {
                setLoading(false);  // Set loading to false after data is fetched
            }
        };

        fetchData();
    }, [isDataLoaded]);  // This hook will run once when the component mounts

    return { defaultParameterConfig, setDefaultParameterConfig, isDataLoaded, setIsDataLoaded };
};

export default useDefaultParameterConfig;